"use strict";

export default class Vehicles {
  constructor($q, API) {
    this.$q = $q;
    this.API = API;
  }

  getVehicleList(groupIds, targetAccount = null) {
    const baseUrl = "v1/vehiclelist"
    const param = [];
    param.push.apply(param, this.API.getArrayQuery("includeGroupIds", groupIds));

    if (targetAccount !== null) {
      param.push(`targetAccount=${targetAccount}`);
    }
    let query = "";
    if (param.length > 0) {
      query += `?${param.join("&")}`;
    }

    const url = baseUrl + query;
    const ctx = this;
    const promise = new Promise((resolve, reject) => {
      ctx.API.get(url)
        .success(vehicles => resolve(vehicles))
        .error(err => reject(err));
    });
    return promise;
  }


  // TODO: DEPRECATE due to performance with 20k+ items
  getVehicles(groupIds, searchTerm, paging, targetAccount = null) {
    let deferred = this.$q.defer();
    let url = "v1/vehicles";

    let param = [];
    param.push.apply(param, this.API.getPagingQuery(paging));
    param.push.apply(param, this.API.getArrayQuery("includeGroupId", groupIds));
    if (searchTerm) param.push("searchTerm=" + searchTerm);

    if (targetAccount !== null)
      param.push("targetAccount=" + targetAccount);

    if (param.length > 0) {
      url += "?" + param.join("&");
    }

    this.API.get(url)
      .success((vehicles) => {
        //console.log("vehicles: ", vehicles);
        deferred.resolve(vehicles);

      })
      .error((err) => {
        console.log("error: ", err);
        deferred.reject(err);
      });

    return deferred.promise;
  }
}

Vehicles.$inject = ["$q", "FleetPortalAPI"];



// WEBPACK FOOTER //
// ./Common Javascript Files/AngularJS/alk-fleetlink/fleetlink.vehicles.js